export default __webpack_public_path__ + "static/media/Golden Knights.c3ac36af.png";